module.exports = __webpack_public_path__ + "img/PAI_Landing-Page_Mobile_08.2cc68905.jpg";